export default __webpack_public_path__ + "static/media/js.87a6904f.svg";